import { TableColumn } from "./dataInterface";

export const followCallConfigTableColumn: TableColumn = {
  title: "フォローコール設定一覧",
  detail: true,
  detailTitle: "フォローコール設定詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "フォローコール設定登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "コピー",
      width: "45px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
    {
      name: "削除",
      width: "40px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "category_name",
      name: "カテゴリ",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "category",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_id",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "product",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "follow_call_entry_status_conf",
      name: "ステータスの指定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "follow_call_entry_status",
      name: "指定ステータス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: true,
      edit: true,
      editType: "text",
      editId: "id",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "follow_call_base_day_conf",
      name: "基準日",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "follow_call_day_offset",
      name: "日時設定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "service_name",
      name: "サービス一覧",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_sale_company_name",
      name: "エントリーパートナー一覧",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  spTier: 'sp_first',
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "サービス一覧",
      subTableColumnLength: "service_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "サービス詳細",
      subTableAdd: true,
      subTableAddTitle: "サービス追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: false,
      subTableEditTitle: "サービス編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "service_name",
          name: "サービス名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "follow_call_service",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "エントリーパートナー一覧",
      subTableColumnLength: "entry_sale_company_length",
      subTableColumnNameWidth: "170px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "エントリーパートナー詳細",
      subTableAdd: true,
      subTableAddTitle: "エントリーパートナー追加",
      subTableAddTitleWidth: "170px",
      subTableEdit: false,
      subTableEditTitle: "エントリーパートナー編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "follow_call_entry_sale_company",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
